<template lang="pug">
  form(@submit.prevent="sendPassRecoveryEmail")
    p.text-muted
      | Le enviaremos a su correo electrónico asociado a su cuenta un enlace para reiniciar su contraseña.
    .form-group.mb-4
      label Correo electrónico
      input.form-control(type="email" v-model="email")
    .form-group.mb-2
      button#buttonSend.w-100(type="submit") Enviar
    .form-group.text-center.mb-0
      router-link(to="/login") < Volver
</template>

<script>
import LoginLayout from '@/layouts/LoginLayout'
import { appisAmulenCore } from '../utils/axiosInstances'

export default {
  name: 'RecoverPass',
  data () {
    return {
      email: '',
      client: {
        id: localStorage.getItem('clientId')
      }
    }
  },
  created () {
    this.$emit('update:layout', LoginLayout)
  },
  methods: {
    async sendPassRecoveryEmail (email, client) {
      await appisAmulenCore.post('/user/email-change-pass', {
        email: this.email,
        client: this.client.id
      })
      alert('Correo enviado correctamente!')
    }
  }
}
</script>

<style lang="stylus">
  #buttonSend
    background: #43ADE1
    border: none
    color: white
    border-radius: 6px
    height: 40px
  #buttonSend:hover
    background: #2D9CD3
</style>
